export default {
  user: null,
  navigationDrawer: false,
  filteredFlightsList: [],
  filteredFlightsVisitedList: []
}
